// 权限按钮
import Vue from 'vue'
Vue.directive('hasPermission', {
  update(el, binding, vnode) {
    let permissionList = vnode.context.$store.state.role.stringPermissions
    if (permissionList && permissionList.length &&
      !permissionList.includes(binding.value)) {
      el.style.display = 'none'
    } else {
      el.style.display = 'inline-block'
    }
  }
})

// 防止重复点击
Vue.directive('preventClick', {
  inserted(el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true
        setTimeout(() => {
          el.disabled = false
        }, 3000)
      }
    })
  }
})
